import React from 'react';
import { Text } from '@ui';
// The row grid lives with SyncStatusRow but is written as attribute selectors
// (`[class*='qmb-ui-sync-status-row']`) precisely so any element carrying those
// class names picks it up. Importing it here is what keeps this panel lined up
// with the QBO and Payrix ones instead of re-deriving — and drifting from —
// their layout.
//
// Relative rather than via `@features`: jest's moduleNameMapper resolves the
// alias before its stylesheet stub, so an aliased .scss import reaches Jest as
// real SCSS and fails the suite on a parse error.
import '../../../Integrations/SyncStatusRow/SyncStatusRowStyles.scss';
import './PushDeviceRowStyles.scss';
const BLANK_VALUE = '—';
/**
 * One label/value line in the push-device panel. Reuses the sync-status-row
 * grid the QBO and Payrix panels use, so the three panels line up visually
 * without this one re-deriving their layout.
 */
export function PushDeviceRow({ label, value, monospace = false, children }) {
    return (React.createElement("div", { className: "qmb-ui-sync-status-row" },
        React.createElement("div", { className: "sync-status-row__label-cell" },
            React.createElement(Text, { variant: "body", className: "sync-status-row__label" }, label)),
        React.createElement("div", { className: "sync-status-row__status-cell" }, children !== null && children !== void 0 ? children : (React.createElement(Text, { variant: "body", className: monospace ? 'push-device-row__value--monospace' : undefined }, value || BLANK_VALUE)))));
}
